<template>
  <a :href="cardInfo.link" target="_blank" class="scene-box">
    <div class="title"><span>{{cardInfo.title}}</span></div>
    <div class="text"><span>{{cardInfo.text}}</span></div>
  </a>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['cardInfo'],
  components: {
  }
}
</script>

<style lang="scss" scoped>
  @import '@/style/app.sass';

  .scene-box {
    display: block;
    width: calc(33.3% - 17px);
    background: #fff;
    margin-bottom: 26px;
    margin-right: 24px;
    border-radius: 5px;
    box-shadow: 0px 2px 14px 2px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    &:nth-of-type(3n) {
      margin-right: 0;
    }
    @include mobile {
      width: 100%;
      margin-right: 0;
      margin-bottom: 16px;
    }

    .title {
      display: flex;
      align-items: center;
      height: 75px;
      font-size: 18px;
      font-weight: 500;
      color: #fff;
      padding: 16px 30px 14px;
      text-align: center;
      line-height: 1.3;
      background-image: url('../../image/home/card-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      border-radius: 5px 5px 0 0;
      box-sizing: border-box;
      @include mobile {
        font-size: 16px;
        padding: 8px 12px 8px;
        height: 54px;
      }
      >span {
        width: 100%;
        text-align: center;
        @include limit-line-numbers(2);
      }
    }

    .text {
      font-size: 15px;
      font-weight: 400;
      color: $font-color2;
      line-height: 23px;
      padding: 14px 30px 20px;
      text-align: justify;
      @include mobile {
        font-size: 12px;
        padding: 8px 12px 8px;
      }
      >span {
        @include limit-line-numbers(3);
      }

    }
  }
</style>
